import styled from '@emotion/styled';
import React from 'react';

import { PlanCode, billingPlans, getCurrencySymbol } from '@/features/billing';
import { useWorkspaceId } from '@/hooks/router';
import { useGetCustomer } from '@/queries/subscriptions/queries';

interface BillingSelectedPlanInfoProps {
  plan?: PlanCode;
}

export function BillingSelectedPlanInfo({
  plan,
}: BillingSelectedPlanInfoProps) {
  const workspaceId = useWorkspaceId();
  const { data: customer } = useGetCustomer(Number(workspaceId));
  const billingPlan = plan && billingPlans[plan];

  if (!billingPlan) return null;

  return (
    <PlanInfoContainer>
      <Content>
        Your plan: {billingPlan.name}
        <PlanTypeTag>{billingPlan.type}</PlanTypeTag>
      </Content>
      <div>
        {getCurrencySymbol(customer?.currency)}
        {billingPlan.price}/month
      </div>
    </PlanInfoContainer>
  );
}

const PlanInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 24px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.grey[5]};
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.typography.colorPrimary};
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PlanTypeTag = styled.div`
  color: ${(props) => props.theme.typography.colorPrimary};
  background: ${(props) => props.theme.colors.yellow[50]};
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  padding: 0 8px;
  border-radius: 8px;
`;
